// TODO: remove once the backend Receipt FAQ endpoint is available.
export const RECEIPT_FAQ = [
  {
    title: "What is Digital Receipt?",
    text: "Digital Receipt is a fraud prevention program that enrolls your business in Mastercard Consumer Clarity and Visa Order Insight. When a cardholder contacts their bank about a transaction, their bank can instantly retrieve your order details (the purchase amount, items bought, and your business information) directly in their banking app or call center system. This helps cardholders recognize the charge and prevents disputes before they become chargebacks."
  },
  {
    title: "What programs am I enrolled in?",
    text: "When you enroll, your business is registered with the supported programs: Mastercard Consumer Clarity (via Ethoca) and Visa Order Insight (via Verifi). Each one shares your order details with the issuing banks on that card network."
  },
  {
    title: "How much does Digital Receipt cost?",
    text: "Digital Receipt charges a small flat fee per bank lookup, with no monthly subscription. You are only billed when a bank actually looks up one of your transactions. Your per-lookup fee is shown on each row of the All page and on your invoices."
  },
  {
    title: "When will I start getting charged?",
    text: "Billing starts once your enrollment is active and banks begin looking up your transactions. You are not charged during the review period before activation."
  },
  {
    title: "Where can I see my lookup charges?",
    text: "Every lookup and its fee appears in the table on the Digital receipt page, which you can filter and export. Your total lookup fees also appear in the Lookup fees card and on your invoices."
  },
  {
    title: "Does Digital Receipt work for all card types?",
    text: "Digital Receipt covers the card networks of the programs you are enrolled in: Mastercard through Consumer Clarity and Visa through Order Insight."
  },
  {
    title: "How long does enrollment take?",
    text: "Enrollment usually takes about 1 business day. We will email you when Digital Receipt is active for your account; until then you will see an Enrollment in progress status."
  },
  {
    title: "What information do I need to provide to enroll?",
    text: "You provide your business name, website and description, an optional logo, your business address and product details, your billing descriptors, BIN codes and CAID codes, your support contact details, and links to your terms, refund and cancellation policies. You can enter all of this on the Configure page."
  },
  {
    title: "What is an Acquirer BIN and CAID and where do I find them?",
    text: "An Acquirer BIN (Bank Identification Number) and CAID (Card Acceptor ID) are identifiers your payment processor or acquirer assigns to your merchant account so the card networks can match a transaction to your business. You can find them on your processor or acquirer statements, or by asking your acquirer's support team."
  }
]
